import { ArgumentsCamelCase } from 'yargs'
import { checkIfNewerVersionAvailableAndLog, getCustomComponentLibraryConfig } from '../../util'
import { build, buildComponentAndDeploy } from '../../build_components'
import { getCCLClient } from '../../getCCLClient'
import { BuildError } from '../../buildError'

export const deployCommand = async (argv: ArgumentsCamelCase<{ 'dry-run': boolean, 'skip-updates-check': boolean, verbose?: boolean, header?: string[], 'url'?: string, 'access-token'?: string, 'path-to-unix-socket'?: string }>) => {
  const cclc = getCustomComponentLibraryConfig()
  if (!cclc) {
    throw new BuildError(
      'Missing required name field in custom component library config (package.json -> retoolCustomComponentLibraryConfig.name must be set)',
    )
  }

  const { name, label, entryPoint, outputPath } = cclc

  if (!name || !label || !entryPoint || !outputPath) {
    throw new BuildError(
      'Missing required fields in custom component library config. This can be found in your package.json under the retoolCustomComponentLibraryConfig key',
    )
  }

  if (argv['dry-run']) {
    await build(false)
  } else {
    const ccApi = await getCCLClient(false, argv.header, 'default', argv['url'], argv['access-token'], argv['path-to-unix-socket'], argv.verbose || false)

    const customComponentLibraries = await ccApi.customComponentLibrariesGet()
    const libraryUuid = customComponentLibraries.data.find((ccl) => ccl.name === name)?.id
    if (!libraryUuid) {
      throw new Error(
        `Could not find Library with name (${name}). Please check your package.json retoolCustomComponentLibraryConfig value.`,
      )
    }
    await buildComponentAndDeploy(libraryUuid, ccApi, false, argv.verbose || false)
  }

  await checkIfNewerVersionAvailableAndLog(argv['skip-updates-check'])
}
